// extracted by mini-css-extract-plugin
module.exports = {"bxTextTruncateEnd":"Title-module--bx--text-truncate--end--zhp8V","bxTextTruncateFront":"Title-module--bx--text-truncate--front--4MOyt","title":"Title-module--title--1BOG_"};